import React from 'react';

import { MedicamentoConcentracao } from '@/models/Medicamento';
import { ConcentracaoBoxMenu, ConcentracaoOption } from './styles';

export interface MenuConcentracoesProps {
  options: MedicamentoConcentracao[];
  onConcentracaoSelect?: (concentracao: MedicamentoConcentracao) => void;
  style?: React.CSSProperties;
  className?: string;
}

const MenuConcentracoes: React.FC<MenuConcentracoesProps> = ({
  options,
  onConcentracaoSelect,
  style,
  className,
}) => {
  return (
    <ConcentracaoBoxMenu style={style} className={className}>
      {options.map(concentracao => (
        <ConcentracaoOption
          key={concentracao.reference}
          onClick={() =>
            onConcentracaoSelect && onConcentracaoSelect(concentracao)
          }
        >
          {concentracao.display}
        </ConcentracaoOption>
      ))}
    </ConcentracaoBoxMenu>
  );
};

export default MenuConcentracoes;
